import BaseCellHandler from './BaseCellHandler';
import ConcordanceWrapper from '@/views/storyboard/charts/concordance/ConcordanceWrapper';
import {ConcordanceChartData} from 'entities/chartData';


class ConcordanceCellHandler extends BaseCellHandler {
    endpointUrl = window.URLS.getConcordance;

    renderContent() {
        const {data, queryDuration} = this.state;
        const {chartQuery, previewOnly, chartSettingsView} = this.props;

        return (
            <ConcordanceWrapper
                data={data as ConcordanceChartData[]}
                fieldToQuery={chartQuery.fields_to_query}
                previewOnly={previewOnly}
                queryDuration={queryDuration}
                chartSettingsView={chartSettingsView}
            />
        );
    }
}

export default ConcordanceCellHandler;
